import './App.css';
import Main from './Page Elements/main.tsx';

function App() {
  return (
    <div className="App">

      <Main />
    </div>
  );
}

export default App;
